import React from "react";
import "./Landscape.css";
import { useAgentsLocal } from "./useAgentsLocal";
import LexacquireTopnav from "./lexacquiretopnav";
import { useNavigate } from "react-router-dom";

export default function Landscape() {
  const { agents, loading } = useAgentsLocal();
  console.log("rawAgents[0]:", agents[0]);
  const navigate = useNavigate();
  const [expandedCats, setExpandedCats] = React.useState(new Set());

  // ─── Compute KPIs ───
  const totalAgents = agents.length;
  const now = new Date();
  const newThisMonth = agents.filter((a) => {
    const dt = new Date(a.createdAt);
    return (
      dt.getMonth() === now.getMonth() && dt.getFullYear() === now.getFullYear()
    );
  }).length;

  // ─── Build categoryData for “category icon grid” ───
  const categoryData = React.useMemo(() => {
    const map = {};
    agents.forEach((a) => {
      const cat = a.category || "Uncategorized";
      if (!map[cat]) {
        map[cat] = {
          id: cat.toLowerCase().replace(/\s+/g, "-"),
          name: cat,
          count: 0,
          totalTrans: 0,
          description: `AI agents for ${cat.toLowerCase()}.`,
          logos: [],
        };
      }
      map[cat].count += 1;
      map[cat].totalTrans += a.transactions || 0;

      // use a.logo_url since raw objects have "logo_url"
      const url = a.logo_url || a.logoUrl || a.logo;
      if (url) {
        map[cat].logos.push({
          id: a.id,
          logoUrl: url,
          name: a.name,
        });
      }
    });

    return Object.values(map).map((c) => {
      const allLogos = c.logos;
      const moreCount = allLogos.length > 5 ? allLogos.length - 5 : 0;
      const avgTransactions = c.totalTrans / c.count || 0;
      return {
        ...c,
        allLogos,
        logos: allLogos.slice(0, 30),
        moreCount,
        avgTransactions,
      };
    });
  }, [agents]);

  console.log("categoryData logos for each category:", categoryData);

  // ─── expand/collapse handler ───
  const toggleCategory = (catId) => {
    setExpandedCats((prev) => {
      const copy = new Set(prev);
      if (copy.has(catId)) copy.delete(catId);
      else copy.add(catId);
      return copy;
    });
  };

  return (
    <div className="landscape-container">
      {/* ─── TOP NAV (tabs + search + buttons) ─── */}
      <LexacquireTopnav />

      {loading ? (
        <p className="landscape-loading">Loading…</p>
      ) : (
        <>
          {/* ─── HERO CTA BANNERS ─── */}
          <div className="landscape-hero-banners">
            <div className="hero-banner left-panel">
              <div className="hero-text">Need Custom AI Agent?</div>
              <div className="hero-buttons">
                <button
                  className="btn-pink-gradient"
                  onClick={() => navigate("/lexacquire/request")}
                >
                  Request Agent →
                </button>
                <button className="btn-outline-purple">
                  View Agencies →
                </button>
              </div>
            </div>
            <div className="hero-banner right-panel">
              <div className="hero-text">Have an AI Agent?</div>
              <button
                className="btn-green-gradient"
                onClick={() => navigate("/lexacquire/submit")}
              >
                Submit Agent →
              </button>
            </div>
          </div>

          {/* ─── LANDSCAPE HEADLINE SECTION ─── */}
          <div className="landscape-headline-section">
            <h1 className="landscape-title">AI Agents Market Landscape</h1>
            <p className="landscape-subtitle">
              Interactive ecosystem map of AI agents, tools, and assistants
            </p>
            <div className="landscape-bullet-stats">
              <span className="bullet bullet-blue"></span> May 2025
              <span className="bullet bullet-green"></span> Categories:{" "}
              {categoryData.length}
              <span className="bullet bullet-purple"></span> Agents:{" "}
              {totalAgents}
            </div>
          </div>

          {/* ─── KPI BAR ─── */}
          <div className="landscape-kpi-bar">
            <div className="kpi-item">
              <div className="kpi-label">Total Agents</div>
              <div className="kpi-value">{totalAgents.toLocaleString()}</div>
            </div>
         
         
          {/* 
<div className="kpi-item">
  <div className="kpi-label">New This Month</div>
  <div className="kpi-value">{newThisMonth}</div>
</div>
*/}

<div className="kpi-item">
  <div className="kpi-label">New This Month</div>
  <div className="kpi-value">600</div>
</div>


            {/* ─── Simplified “Filter” box ─── */}
            <div className="kpi-item">
              <div className="kpi-label">Filter</div>
              <div className="filter-inline-group">
                <label className="filter-inline-label">
                  <input type="checkbox" />
                  <span className="legend-text">Free</span>
                </label>
                <label className="filter-inline-label">
                  <input type="checkbox" />
                  <span className="legend-text">Open Source</span>
                </label>
                <label className="filter-inline-label">
                  <input type="checkbox" defaultChecked />
                  <span className="legend-text">Featured</span>
                </label>
              </div>
            </div>
          </div>

          {/* ─── CATEGORY ICON GRID ─── */}
          <div className="landscape-categories-grid">
            {categoryData.map((cat) => {
              const isExpanded = expandedCats.has(cat.id);
              const logosToShow = isExpanded ? cat.allLogos : cat.logos;

              return (
                <div key={cat.id} className="category-card">
                  <div className="category-header">
                    <h3 className="category-name">{cat.name}</h3>
                    <span className="category-count">{cat.count}</span>
                  </div>
                  <p className="category-description">{cat.description}</p>

                  <div className="category-logos">
                    {logosToShow.map((logo) => (
                      <div key={logo.id} className="logo-tile">
                        <img src={logo.logoUrl} alt={logo.name} />
                      </div>
                    ))}
                  </div>

                  {cat.moreCount > 0 && (
                    <button
                      className="btn-show-more"
                      onClick={() => toggleCategory(cat.id)}
                    >
                      {isExpanded
                        ? "Show Less ↑"
                        : `Show ${cat.moreCount} More ↓`}
                    </button>
                  )}
                </div>
              );
            })}
          </div>

       

          {/* ─── FEATURED AI AGENTS FOOTER ─── */}
          <div className="featured-ai-footer">
            <div className="featured-footer-header">
              <h3 className="featured-footer-title">Featured AI Agents</h3>
              <span className="footer-help-icon">?</span>
            </div>
            <div className="featured-footer-list">
              {agents
                .filter((a) => a.featured)
                .sort((a, b) => a.featuredOrder - b.featuredOrder)
                .map((a) => (
                  <div key={a.id} className="footer-agent-card">
                    <img
                      src={a.logo_url || a.logoUrl || a.logo}
                      alt={a.name}
                      className="footer-agent-logo"
                    />
                    <div className="footer-agent-text">
                      <div className="footer-agent-name">{a.name}</div>
                      <div className="footer-agent-desc">{a.description}</div>
                    </div>
                    <a
                      href={a.url}
                      target="_blank"
                      rel="noreferrer"
                      className="footer-agent-link"
                    >
                      Discover More →
                    </a>
                  </div>
                ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
